// не удалять импорты, нужны что бы существовали переменые на первом серв. ренд.
import './$util';
import './$ui';
//import './$axiosInstance';
// -- не удалять импорты, нужны что бы существовали переменые на первом серв. ренд. --

import { set$store } from './$store';
import { set$axiosInstance } from './$axiosInstance';

export { set$axiosInstance, set$store };



// WEBPACK FOOTER //
// ./src/tools/declare/global/initialGlobalModules.ts